import { Table, Typography } from 'antd';

import { PREFIX, TASK_LIST_HEADER, U_KEY } from '@app/constants';
import { ChangeEmployeeModal } from '@app/pages/TasksList/components/ChangeEmployeeModal';
import { TableHeader } from '@app/pages/TasksList/components/TableHeader';
import { useTaskListContext } from '@app/providers/TaskListProvider';

import '@pages/TasksList/styles/TaskList.desktop.scss';

export const TaskListRegistry = () => {
  const {
    tableHeaderForm,
    handleReset,
    selectedStatuses,
    setSelectedStatuses,
    selectedCreators,
    setSelectedCreators,
    selectedEmployee,
    setSelectedEmployee,
    searchTasks,
    selectorFilterData,
    selectFilterGroup,
    periodTypeFilterList,
    statusesFilterList,
    ownersFilterList,
    creatorsFilterList,
    isRegistryTableLoading,
    tableData,
    rowSelection,
    pagination,
    MassActionButton,
    branchesFilterList,
    selectedBranches,
    setSelectedBranches,
    selectedRowKeys,
    taskTypesFilterList,
    selectedTaskTypes,
    setSelectedTaskTypes,
  } = useTaskListContext();

  return (
    <div className={`${PREFIX}task-list`}>
      <TableHeader
        form={tableHeaderForm}
        submitForm={searchTasks}
        handleFilterClick={selectFilterGroup}
        filtersData={selectorFilterData}
        handleReset={handleReset}
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
        selectedEmployee={selectedEmployee}
        setSelectedEmployee={setSelectedEmployee}
        selectedCreators={selectedCreators}
        setSelectedCreators={setSelectedCreators}
        periodTypeFilterList={periodTypeFilterList}
        statusesFilterList={statusesFilterList}
        ownersFilterList={ownersFilterList}
        creatorsFilterList={creatorsFilterList}
        branchesFilterList={branchesFilterList}
        selectedBranches={selectedBranches}
        setSelectedBranches={setSelectedBranches}
        taskTypesFilterList={taskTypesFilterList}
        selectedTaskTypes={selectedTaskTypes}
        setSelectedTaskTypes={setSelectedTaskTypes}
      />
      <div className="tasks-count-container">
        <Typography.Text className="tasks-count" type="secondary">
          {`Выбрано ${selectedRowKeys.length} из ${
            pagination?.total || 0
          } задач`}
        </Typography.Text>
        {MassActionButton}
      </div>
      <Table
        className="task-registry-table"
        columns={TASK_LIST_HEADER}
        loading={isRegistryTableLoading}
        dataSource={tableData}
        rowSelection={rowSelection}
        rowKey={(record) => String(record[U_KEY])}
        rowClassName={(record) => `row-${String(record[U_KEY])}`}
        pagination={pagination}
      />
      {MassActionButton}
      <ChangeEmployeeModal />
    </div>
  );
};
